<template>
	<div>
		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-field :count="256">
					<q-input
						v-model="title"
						:float-label="$t('title')"
						ref="title"
						:error="$v.title.$error"
						@input="$v.title.$touch"
						:disable="!managerTrainings"
					/>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-12">
				<span class="caption q-mb-sm block">{{ $t('introduction') }}</span>
				<q-field :count="1024"> 
					<q-input v-model="descriptionWithoutHTML" style="display: none;"></q-input>
					<q-editor
						:content-style="$v.descriptionWithoutHTML.$error ? { border: '1px solid red'}: {}"
						v-model="description"
						@input="$v.descriptionWithoutHTML.$touch"
						:toolbar="[
							['bold', 'italic', 'strike', 'underline'],
							['left', 'center', 'right', 'justify'],
							['link', 'upload'],
							[
								{
									label: null,
									icon: 'fas fa-font',
									fixedLabel: true,
									fixedIcon: true,
									list: 'no-icons',
									options: [
										'p',
										'h1',
										'h2',
										'h3',
										'h4',
										'h5',
										'h6',
										'code',
									],
								},
								{
									label: null,
									icon: 'fas fa-text-height',
									fixedLabel: true,
									fixedIcon: true,
									list: 'no-icons',
									options: [
										'size-1',
										'size-2',
										'size-3',
										'size-4',
										'size-5',
										'size-6',
										'size-7',
									],
								},
								'removeFormat',
							],
							['quote', 'unordered', 'ordered'],
							['custom_btn'],
						]"
						:definitions="{
							bold: { label: null, icon: 'fas fa-bold' },
							italic: { label: null, icon: 'fas fa-italic' },
							strike: { label: null, icon: 'fas fa-strikethrough' },
							underline: { label: null, icon: 'fas fa-underline' },
							left: { label: null, icon: 'fas fa-align-left' },
							center: { label: null, icon: 'fas fa-align-center' },
							right: { label: null, icon: 'fas fa-align-right' },
							justify: { label: null, icon: 'fas fa-align-justify' },
							link: { label: null, icon: 'fas fa-link' },
							upload: {
								tip: null,
								icon: 'fas fa-file-image',
								handler: insertImg,
							},
							removeFormat: { label: null, icon: 'fas fa-eraser' },
							quote: { label: null, icon: 'fas fa-quote-right' },
							unordered: { label: null, icon: 'fas fa-list-ul' },
							ordered: { label: null, icon: 'fas fa-list-ol' },
						}"
					>
						<q-btn
							slot="custom_btn"
							dense
							flat
							color="black"
							icon="fal fa-code"
							label="HTML"
							@click="show_description_html = true"
						/>
					</q-editor>
				</q-field>
			</div>

			<div class="col-xs-12 col-sm-6" v-if="selected_client_params.group_training_use_basic">
				<q-select
					v-model="group_training_type"
					ref="group_training_type"
					:options="group_training_types"
					:float-label="$t('capacitation')"
					:error="$v.group_training_type.$error"
					@input="$v.group_training_type.$touch"
					:disable="!managerTrainings"
				/>
			</div>

			<div
				class="col-xs-12"
				:class="selected_client_params.group_training_use_workload && 'col-sm-6'"
				ref="score"
				v-if="selected_client_params.group_training_use_score && trainingTypeUseScore"
			>
				<q-input
					v-model="score"
					:float-label="$t('score')"
					type="number"
					:error="$v.score.$error"
					@input="$v.score.$touch"
					v-if="!selected_client_params.group_training_use_static_score"
					:disable="!set_score || !managerTrainings"
				/>

				<q-select
					v-model="score"
					:options="scoresOptions"
					:float-label="$t('score')"
					:error="$v.score.$error"
					@input="$v.score.$touch"
					v-if="selected_client_params.group_training_use_static_score"
					:disable="!set_score || !managerTrainings"
				/>
			</div>

			<div
				class="col-xs-12 col-sm-6"
				v-if="selected_client_params.group_training_use_workload"
			>
				<q-input
					v-model="workload"
					ref="workload"
					:float-label="$t('workload_in_hours')"
					type="number"
					@input="$v.workload.$touch"
					:error="$v.workload.$error"
					:disable="!managerTrainings"
				/>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="isEnableCode">
				<q-field :helper="$t('training_code_helper_message')">
					<q-input
						type="text"
						v-model="code"
						:float-label="$t('training_code')"
						:disable="!managerTrainings"
					/>
				</q-field>
			</div>
		</div>

		<div class="row q-mb-lg" v-if="isSence">
			<q-card style="width: 100%;">
				<q-card-title class="bg-blue text-white" style="height: 60px">
					<q-checkbox
						keep-color
						v-model="hasSence"
						color="white"
						:label="$t('sence_integration')"
						class="q-mb-md"
					/>
				</q-card-title>
				<q-card-main v-if="hasSence">
					<div class="row gutter-sm">
						<div class="col-xs-12 col-sm-6">
							<q-field :helper="$t('sence_code_hint')">
								<q-input
									type="text"
									v-model="sence.cod_sence"
									:float-label="$t('sence_code')"
									:error="$v.sence.cod_sence.$error"
									@input="$v.sence.cod_sence.$touch"
								/>
							</q-field>
						</div>
						<div class="col-xs-12 col-sm-6">
							<q-field>
								<q-input
									type="text"
									v-model="sence.cod_curso"
									:float-label="$t('sence_course')"
									:error="$v.sence.cod_curso.$error"
									@input="$v.sence.cod_curso.$touch"
								/>
							</q-field>
						</div>
					</div>
				</q-card-main>
			</q-card>
		</div>

		<div class="row gutter-sm q-mb-lg">
			<div class="col-xs-12 col-sm-12">
				<q-select
					v-model="tag"
					ref="tag"
					:options="optionTags"
					:float-label="$t('tags')"
					:error="$v.tag.$error"
					@input="$v.tag.$touch"
					multiple
					chips
					filter
					autofocus-filter
					:disable="!managerTrainings"
				/>
			</div>

			<div class="col-xs-12 col-sm-12" v-if="login_use_portfolio_page">
				<q-select
					v-model="on_portfolio"
					ref="on_portfolio"
					:options="[
						{ value: true, label: $t('yes') },
						{ value: false, label: $t('no') },
					]"
					:float-label="$t('show_course_on_portfolio')"
					:disable="!managerTrainings"
				/>
			</div>

			<div class="col-xs-12 col-sm-12 ">
				<div class="row gutter-sm flex">
					<div class="col-12" v-if="id_training && isBoticario">
						<p class="caption">{{ $t('certificate') }}</p>
						<uploader
							content_type="images"
							@fileUploaded="certificateImageUploaded"
							:multiple="false"
							filename="certificate"
							:id="id_training"
							custom_certificate_module_path="group_trainings"
							:disable="!managerTrainings"
						/>

						<p v-if="certificate_image_url" class="q-mt-md file-url">
							<q-icon name="fal fa-check" color="positive" />
							<a :href="certificate_image_url" target="_blank"> {{ $truncateLink(certificate_image_url) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">{{ $t('image') }}</p>
						<uploader
							content_type="images"
							@fileUploaded="imageUploaded"
							:multiple="false"
							:cropper="isPFSG ? false : true"
							:aspect_ratio="16/9"
							:aspect_ratio_string="'16/9'"
							:disable="!managerTrainings"
						/>

						<p v-if="image_url" class="q-mt-md file-url">
							<q-icon name="fal fa-check" color="positive" />
							<a :href="image_url" target="_blank"> {{ $truncateLink(image_url) }}</a>
						</p>
					</div>
					<div class="col-xs-12 col-sm-6">
						<p class="caption">
							{{ $t('alt_image') }}
							<q-icon
								name="fal fa-question-circle"
								size="1.5rem"
								color="grey"
								class="q-ml-sm q-pb-sm"
							>
								<q-tooltip
									class="custom-tooltip"
									anchor="top left"
									self="bottom right"
								>
									{{ $t('alt_image_information_helper') }}
								</q-tooltip>
							</q-icon>
						</p>
						<div class="flex justify-between">
							<template v-for="lang in languages" class="row flex">
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'pt-br'">
									<q-input
										v-model="language_br"
										:float-label="$t(`${lang.name}`)"
										ref="language_br"
										:error="$v.language_br.$error"
										@input="$v.language_br.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'en-us'">
									<q-input
										v-model="language_us"
										:float-label="$t(`${lang.name}`)"
										ref="language_us"
										:error="$v.language_us.$error"
										@input="$v.language_us.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'es-es'">
									<q-input
										v-model="language_es"
										:float-label="$t(`${lang.name}`)"
										ref="language_es"
										:error="$v.language_es.$error"
										@input="$v.language_es.$touch"
									/>
								</q-field>
								<q-field :count="170" :key="lang.id" v-if="lang.code === 'fr-fr'">
									<q-input
										v-model="language_fr"
										:float-label="$t(`${lang.name}`)"
										ref="language_fr"
										:error="$v.language_fr.$error"
										@input="$v.language_fr.$touch"
									/>
								</q-field>
							</template>
						</div>
					</div>
				</div>
			</div>

			<div class="col-xs-12 col-sm-6">
				<q-field :helper="`${$t('date_for_training_to_be_unpublished')}`">
					<q-datetime
						v-model="unpublish_date"
						ref="unpublish_date"
						type="date"
						:float-label="$t('unpublish_date')"
						format="DD/MM/YYYY"
						clearable
						:disable="!managerTrainings"
					/>
				</q-field>
			</div>
			<div class="col-xs-12 col-sm-6">
				<inputExpireCertificate
					v-if="selected_client_params.use_group_trainings_certificate_expiration"
					:disableInput="!managerTrainings"
					@fnInDays="fnInDays"
					:qty_days="qty_days"
					ref="inputExpireCertificate"
				/>
			</div>
		</div>

		<q-tabs v-model="tab" color="secondary" class="shadow-1">
			<q-tab
				slot="title"
				name="permissions"
				icon="fal fa-clipboard-list-check"
				:label="$t('permissions')"
			/>

			<q-tab-pane name="permissions" class="q-px-lg q-pb-xl">
				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('areas') }}</p>
						<q-checkbox
							class="q-mb-sm"
							:disable="!managerTrainings"
							v-model="all_areas"
							:val="true"
							:label="$t('select_all_areas')"
							@input="checkAllAreas()"
						/>
						<select-multiple
							label=""
							:filters="area"
							:options="areas"
							@on_value="area = $event"
							:error="$v.area.$error"
							:input="changeAreas"
							:disable="!managerTrainings"
						/>
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox
									v-model="all_profiles"
									:val="true"
									:label="$t('all')"
									@input="checkAll()"
									:disable="!managerTrainings"
								/>
							</div>

							<div
								class="col-xs-12 col-sm-4"
								v-for="(item, index) in profiles"
								:key="index"
								:class="getErrorClass($v.profile.$error)"
							>
								<q-checkbox
									keep-color
									v-model="profile"
									ref="profile"
									:val="item.value"
									:label="item.label"
									@input="changeProfiles()"
									:color="getErrorColor($v.profile.$error)"
									:disable="!managerTrainings"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="row gutter-sm q-mt-md" v-if="useTrainingSubscription">
					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('mandatory_areas') }}</p>
						<q-checkbox
							class="q-mb-sm"
							:disable="!managerTrainings"
							v-model="all_mandatory_areas"
							:val="true"
							:label="$t('select_all_areas')"
							@input="checkAllMandatoryAreas()"
						/>
						<select-multiple
							label=""
							:filters="mandatory_areas"
							:options="mandatoryAreas"
							@on_value="mandatory_areas = $event"
							:error="$v.mandatory_areas.$error"
							:input="$v.mandatory_areas.$touch"
							:disable="!managerTrainings"
						/>
					</div>

					<div class="col-xs-12 col-sm-12">
						<p class="caption">{{ $t('mandatory_profiles') }}</p>

						<div class="row gutter-sm">
							<div class="col-xs-12 col-sm-12">
								<q-checkbox
									v-model="all_mandatory_profiles"
									:val="true"
									:label="$t('all')"
									@input="checkAllMandatoryProfiles()"
									:disable="!managerTrainings"
								/>
							</div>

							<div
								class="col-xs-12 col-sm-4"
								v-for="(item, index) in mandatoryProfiles"
								:key="index"
							>
								<q-checkbox
									keep-color
									v-model="mandatory_profiles"
									ref="mandatory_profiles"
									:val="item.value"
									:label="item.label"
									:error="$v.mandatory_profiles.$error"
									@input="$v.mandatory_profiles.$touch"
									:disable="!managerTrainings"
								/>
							</div>
						</div>
					</div>
				</div>

				<div class="row gutter-sm">
					<div class="col-xs-12 col-sm-12">
						<q-select
							v-model="user_group"
							ref="user_group"
							:options="user_groups"
							:float-label="$t('groups')"
							:error="$v.user_group.$error"
							@input="$v.user_group.$touch"
							multiple
							chips
							:disable="!managerTrainings"
						/>
					</div>
				</div>

				<div class="row gutter-sm q-my-sm" v-if="id_training != 0">
					<div class="col-xs-12 col-sm-11">
						<q-input
							v-model="url_training_portal"
							:float-label="$t('link')"
							:disable="true"
						/>
					</div>

					<div class="col-xs-12 col-sm-1 q-mt-lg">
						<q-btn
							dense
							color="primary"
							icon="fal fa-copy"
							class="full-width"
							@click="copyLink()"
						>
							<q-tooltip>
								{{ $t('copy_link') }}
							</q-tooltip>
						</q-btn>
					</div>
				</div>
			</q-tab-pane>
		</q-tabs>

		<div class="row gutter-sm q-mt-xs">
			<div class="col-12">
				<q-chips-input
					v-model="owners_list"
					:float-label="$t('owners')"
					@remove="removeOwner"
					:disable="!managerTrainings"
				>
					<q-autocomplete
						@search="searchOwner"
						@selected="selectOwner"
						:min-characters="3"
						:value-field="(v) => `${v.full_name} - ${v.email}`"
					/>
				</q-chips-input>
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="far fa-chevron-left"
					@click="$router.push({ name: 'admin_trainings' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
					:disable="!managerTrainings"
				/>
			</div>
		</div>
		<q-modal
			v-model="show_description_html"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			no-backdrop-dismiss
			no-esc-dismiss
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_description_html = false" icon="fas fa-times" />
					<q-toolbar-title>
						HTML
					</q-toolbar-title>
				</q-toolbar>
	
				<div class="layout-padding">
					<div class="row">
						<div class="col-12">
							<q-input
								type="textarea"
								rows="10"
								float-label="HTML"
								v-model="description"
							/>
						</div>
					</div>
	
					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3">
							<q-btn
								color="tertiary"
								class="full-width"
								:label="$t('close')"
								icon="far fa-ban"
								@click="show_description_html = false"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</div>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
import InputExpireCertificate from 'components/admin/shared/InputExpireCertificate'
const { formatDate, addToDate } = date
import SelectMultiple from 'components/utils/SelectMultiple'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'training', 'admin', 'users'] },

	props: ['managerTrainings', 'set_score'],

	data() {
		return {
			language_br: '',
			language_us: '',
			language_es: '',
			language_fr: '',
			all_areas: false,
			all_mandatory_areas: false,
			all_mandatory_profiles: false,
			all_profiles: false,
			area: [],
			code: null,
			description: '',
			group_training_type: '',
			group_training_types: [],
			hasSence: false,
			id_training: '',
			image_url: '',
			certificate_image_url: '',
			mandatory_areas: [],
			mandatory_profiles: [],
			on_portfolio: false,
			owners: [],
			owners_list: [],
			portfolio_order: 9999,
			profile: [],
			score: 0,
			selected_client_params: [],
			sence: {
				cod_curso: null,
				cod_sence: null,
				linea_capacitacion: 3,
			},
			tab: 'permissions',
			tag: [],
			title: '',
			trainings_code: [],
			unpublish_date: null,
			user_group: [],
			workload: 0,
			qty_days_result_expiration: 0,
			qty_days: 0,
			show_description_html: false,
		}
	},

	components: {
		uploader: Uploader,
		inputExpireCertificate: InputExpireCertificate,
		'select-multiple': SelectMultiple,
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/country_areas',
			clients: 'params/clients',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			login_use_portfolio_page: 'params/login_use_portfolio_page',
			profiles: 'registration_lists/profiles',
			scores: 'registration_lists/group_training_scores',
			tags: 'registration_lists/tags',
			user_email: 'common/email',
			user_full_name: 'common/full_name',
			user_groups: 'registration_lists/group_users',
			user_id: 'common/id',
			languages: 'params/languages',
		}),

		getconfig() {
      		let client = this.user_clients.find((obj) => {
        		return obj.id === this.id_user_client_selected
      		})
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		trainingTypeUseScore() {
			let obj = this.group_training_types.find((obj) => obj.value == this.group_training_type)
			return obj ? obj.use_score : true
		},

		optionTags() {
			if (this.tags.length > 0) {
				return this.tags.map((t) => {
					let areas = t.areas.map((a) => a.name)
					return {
						value: t.value,
						label: t.label,
						sublabel: areas.join(', '),
					}
				})
			} else return []
		},

		isSence() {
			return (
				process.env.PROJECT_FOLDER === 'universidadechevrolet' &&
				this.id_user_client_country_selected === 48
			)
		},

		useTrainingSubscription() {
			let client = this.clients.find((obj) => obj.id === this.id_user_client_selected)
			return client ? client.use_training_subscription : false
		},

		mandatoryAreas() {
			return this.areas.filter((e) => this.area.includes(e.value))
		},

		mandatoryProfiles() {
			return this.profiles.filter((e) => this.profile.includes(e.value))
		},

		isEnableCode() {
			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			return client.use_group_training_code
		},

		isPFSG() {
			if (process.env.PROJECT_FOLDER === 'pfsgalaxy') return true
			return false
		},

		currentClient() {
			return process.env.PROJECT_FOLDER
		},

		url_training_portal() {
			let url = process.env.SITE_URL ? process.env.SITE_URL : document.location.origin
			return `${url}/online-courses/${this.id_training}`
		},
		scoresOptions() {
			let scoreOpts = this.scores.map((e) => {
				return {
					value: e.score,
					label: e.label,
				}
			})
			let score = scoreOpts.find((e) => e.value == this.score)
			if (!score) {
				scoreOpts.push({
					value: this.score,
					label: this.score,
				})
			}
			return scoreOpts
		},

		descriptionWithoutHTML() {
			let decodedHtml = this.description.replace(/&nbsp;/g, " ")
                        .replace(/&amp;/g, "&")
                        .replace(/&quot;/g, "\"")
                        .replace(/&lt;/g, "<")
                        .replace(/&gt;/g, ">");
			return decodedHtml.replace(/<\/?[^>]+(>|$)/g, "")
		},

		isBoticario() {
			return process.env.PROJECT_FOLDER == 'acelera'
		}
	},

	methods: {
		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let requestBody = {
					title: this.title,
					description: this.description,
					group_training_type: this.selected_client_params.group_training_use_basic
						? this.group_training_type
						: 2,
					score:
						this.selected_client_params.group_training_use_score &&
						this.trainingTypeUseScore
							? this.score
							: 0,
					group_training_images: this.image_url,
					code: this.code !== null ? this.code : undefined,
					tags: this.tag,
					areas: this.area,
					profiles: this.profile,
					user_groups: this.user_group.length > 0 ? this.user_group : undefined,
					owners: this.owners,
					workload: this.workload,
					on_portfolio: this.on_portfolio,
					portfolio_order: this.on_portfolio ? this.portfolio_order : undefined,
					unpublish_date: this.unpublish_date
						? date.formatDate(this.unpublish_date, 'YYYY-MM-DD')
						: undefined,
					group_training_image_alt_texts: {
						'pt-br': this.language_br ? this.language_br : '',
						'en-us': this.language_us ? this.language_us : '',
						'es-es': this.language_es ? this.language_es : '',
						'fr-fr': this.language_fr ? this.language_fr : '',
					},
				}

				requestBody.qty_certificate_expiration_days = this.qty_days_result_expiration != null || this.qty_days_result_expiration !== 0 
					? this.qty_days_result_expiration
					: null

				if (this.mandatory_areas.length > 0) {
					requestBody.mandatory_areas = this.mandatory_areas.filter((area) =>
						this.area.includes(area)
					)
				}

				if (this.mandatory_profiles.length > 0) {
					requestBody.mandatory_profiles = this.mandatory_profiles.filter((profile) =>
						this.profile.includes(profile)
					)
				}

				if (this.isBoticario && this.id_training !== 0 && this.certificate_image_url) {
					requestBody.group_training_certificate_image_url = this.certificate_image_url
				}

				let endpointUrl
				let httpMethod
				if (this.id_training !== 0) {
					endpointUrl = `/admin_group_trainings/group_trainings/${this.id_training}/`
					httpMethod = 'put'
				} else {
					endpointUrl = '/admin_group_trainings/group_trainings/'
					httpMethod = 'post'
				}

				this.$axios
					.request({
						url: endpointUrl,
						method: httpMethod,
						data: requestBody,
						headers: this.getHeader.headers,
					})
					.then(({ data }) => {
						this.$q.loading.hide()
						this.$emit('updateTraining', data)

						if (this.isSence) {
							let sence = {
								code_sence: this.hasSence ? this.sence.cod_sence : null,
								codigo_curso: this.hasSence ? this.sence.cod_curso : null,
								linea_capacitacion: this.hasSence
									? this.sence.linea_capacitacion
									: null,
							}

							this.$axios
								.post(
									`/webservices/universidadechevrolet/webservice_sence/group_training/${
										this.id_training
									}/`,
									sence,
									this.getHeader
								)
								.catch(console.error)
						}

						this.$router.replace({ params: { id: data.id } })

						this.$q.notify({
							message: this.$t('basic_data_save_success'),
							type: 'positive',
							icon: 'fal fa-save',
						})
					})
					.catch((e) => {
						console.log(e)
						this.$q.loading.hide()

						this.$q.notify({
							message: this.$t('basic_data_save_error'),
							type: 'negative',
							icon: 'fal fa-ban',
						})
					})
			} else {
				this.$formInputErrorFocus(this.$v, this.$refs, 'profile')

				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fal fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		fetchData() {
			this.$q.loading.show()

			this.$axios
				.get(
					'/admin_group_trainings/group_trainings/' + this.id_training + '/',
					this.getHeader
				)
				.then(({ data }) => {
					this.workload = data.workload
					this.title = data.title
					this.description = data.description
					this.score = data.score
					this.group_training_type = data.group_training_type
					this.tag = data.tags
					this.profile = data.profiles
					this.area = data.areas
					this.user_group = data.user_groups
					this.code = data.code
					this.on_portfolio = data.on_portfolio
					this.portfolio_order = data.portfolio_order ? data.portfolio_order : 9999
					this.qty_days = data.qty_certificate_expiration_days

					if (this.$refs.inputExpireCertificate) {
						this.$refs.inputExpireCertificate.updateTypeCalendar(1)
					}
					
					this.unpublish_date = data.unpublish_date
						? date.formatDate(data.unpublish_date, 'YYYY-MM-DDT00:00:00.SSSZ')
						: null

					if (this.unpublish_date)
						this.unpublish_date = addToDate(this.unpublish_date, { days: 1 })

					this.mandatory_areas = data.mandatory_areas
					this.mandatory_profiles = data.mandatory_profiles

					if (data.group_training_image_alt_text) {
						const altTextMap = {}
						data.group_training_image_alt_text.forEach((altTextObj) => {
							altTextMap[altTextObj.language] = altTextObj.alt_text
						})
						this.language_br = altTextMap['pt-br'] || ''
						this.language_us = altTextMap['en-us'] || ''
						this.language_es = altTextMap['es-es'] || ''
						this.language_fr = altTextMap['fr-fr'] || ''
					}
					
					this.owners_list = []
					data.owners_list.forEach((owner) => {
						this.owners_list.push(`${owner.full_name} - ${owner.email}`)
						this.owners.push(owner.id)
					})

					if (this.isSence) {
						this.$axios
							.get(
								`/webservices/universidadechevrolet/webservice_sence/group_training/${
									this.id_training
								}/`,
								this.getHeader
							)
							.then((dataSENCE) => {
								this.sence.cod_sence = dataSENCE.data.code_sence
								this.sence.cod_curso = dataSENCE.data.codigo_curso
								this.hasSence = dataSENCE.data.code_sence ? true : false
							})
							.catch(console.error)
					}

					let obj_img = data.group_training_images.find((obj) => obj.original === true)
					if (obj_img) this.image_url = obj_img.image

					if (this.isBoticario && this.id_training != 0) {
						this.certificate_image_url = data.group_training_certificate_image_url
					}

					this.$q.loading.hide()
				})
				.catch((e) => {
					console.log(e)
					this.$q.loading.hide()
					this.$router.push({ name: 'admin_trainings' })
				})
		},

		imageUploaded(url) {
			this.image_url = url
		},

		certificateImageUploaded(url) {
			this.certificate_image_url = url
		},

		checkAll() {
			if (this.all_profiles) {
				this.profile = this.profiles.map((e) => e.value)
				this.changeProfiles()
			} else this.profile = []
		},

		checkAllAreas() {
			if (this.all_areas) {
				this.area = this.areas.map((e) => e.value)
				this.changeAreas()
			} else this.area = []
		},

		changeAreas() {
			console.log('passando')
			this.$v.area.$touch
			this.mandatory_areas = this.mandatory_areas.filter((e) => this.area.includes(e))
		},

		changeProfiles() {
			this.$v.profile.$touch
			this.mandatory_profiles = this.mandatory_profiles.filter((e) =>
				this.profile.includes(e)
			)
		},

		checkAllMandatoryAreas() {
			if (this.all_mandatory_areas)
				this.mandatory_areas = this.mandatoryAreas.map((e) => e.value)
			else this.mandatory_areas = []

			this.$v.mandatory_areas.$touch
		},

		checkAllMandatoryProfiles() {
			if (this.all_mandatory_profiles)
				this.mandatory_profiles = this.mandatoryProfiles.map((e) => e.value)
			else this.mandatory_profiles = []

			this.$v.mandatory_profiles.$touch
		},

		getErrorColor(state) {
			return state ? 'negative' : ''
		},

		getErrorClass(state) {
			return state ? 'checkbox-error' : ''
		},

		getOrder(name) {
			if (name == 'cancel') {
				return this.$q.platform.is.mobile ? 'order-last' : 'order-first'
			} else if (name == 'save') {
				return this.$q.platform.is.mobile ? 'order-first' : 'order-last'
			}
		},

		searchOwner(terms, done) {
			this.$axios
				.get(`/accounts/get_owners/?search=${terms}`, this.getHeader)
				.then(({ data }) => {
					let users = []

					data.forEach((element) => {
						users.push({
							value: element.id,
							label: `${element.full_name} - ${element.email}`,
							full_name: element.full_name,
							email: element.email,
							id: element.id,
						})
					})

					done(users)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectOwner(item, keyboard) {
			if (!keyboard) this.owners.push(item.id)
		},

		removeOwner({ index, value }) {
			this.owners.splice(index, 1)
		},

		copyLink() {
			this.$copyText(this.url_training_portal).then(
				(e) => {
					this.$q.notify({
						message: this.$t('link_copied_to_clipboard'),
						type: 'positive',
						icon: 'fal fa-copy',
					})
				},
				(e) => {
					console.log(e)
				}
			)
		},

		fnInDays(value) {
			this.qty_days_result_expiration = value
		},

		insertImg() {
			const input = document.createElement('input')
			input.type = 'file'
			input.accept = '.png, .jpg, .gif'
			let file

			input.onchange = (_) => {
				const files = Array.from(input.files)
				file = files[0]

				this.uploadFile(file)
			}
			input.click()
		},
	},

	validations() {
		return {
			title: { required, maxLength: maxLength(256) },
			language_br: { maxLength: maxLength(170) },
			language_us: { maxLength: maxLength(170) },
			language_es: { maxLength: maxLength(170) },
			language_fr: { maxLength: maxLength(170) },

			descriptionWithoutHTML: { required, maxLength: maxLength(1024) },
			// unpublish_date: { minValue: (value) => value > new Date().toISOString() },
			group_training_type: {
				requiredIf: requiredIf(() => {
					return this.selected_client_params.group_training_use_basic
				}),
			},
			score: {
				requiredIf: requiredIf(() => {
					return this.selected_client_params.group_training_use_score &&
						this.trainingTypeUseScore &&
						this.set_score
						? true
						: false
				}),
				maxValue: maxValue(99999),
				minValue: minValue(0),
			},
			workload: { required },
			tag: { required },
			// portfolio_order: {
			//     requiredIf: requiredIf(() => {
			//         return this.on_portfolio
			//     }),
			//     maxValue: maxValue(100),
			//     minValue: minValue(0)
			// },
			area: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			profile: {
				requiredIf: requiredIf(() => {
					if (this.profile.length == 0 && this.area.length == 0) {
						if (
							this.profile.length == 0 &&
							this.area.length == 0 &&
							this.user_group.length == 0
						)
							return true
						else return false
					} else {
						return true
					}
				}),
			},
			mandatory_areas: {
				requiredIf: requiredIf(() => {
					if (this.useTrainingSubscription) {
						return this.mandatory_profiles.length > 0
					} else return false
				}),
			},
			mandatory_profiles: {
				requiredIf: requiredIf(() => {
					if (this.useTrainingSubscription) {
						return this.mandatory_areas.length > 0
					} else return false
				}),
			},
			user_group: {
				requiredIf: requiredIf(() => {
					if (
						this.profile.length == 0 &&
						this.area.length == 0 &&
						this.user_group.length == 0
					) {
						return true
					} else {
						return false
					}
				}),
			},
			sence: {
				cod_sence: {
					requiredIf: requiredIf(() => this.hasSence),
				},
				cod_curso: {
					requiredIf: requiredIf(() => this.hasSence),
				},
			},
		}
	},

	created() {
		this.id_training = this.$route.params.id
		if (this.id_training) {
			this.fetchData()
		} else {
			this.owners.push(this.user_id)
			this.owners_list.push(`${this.user_full_name} - ${this.user_email}`)
		}

		let client = this.clients.find((obj) => {
			return obj.id === this.id_user_client_selected
		})
		this.selected_client_params = client ? client : {}
	},

	watch: {
		training: {
			handler: function(newValue) {
				if (this.training) {
					this.title = this.training.title
					this.description = this.training.description
					this.score = this.training.score
					this.group_training_type = this.training.group_training_type
					this.tag = this.training.tags
					this.profile = this.training.profiles
					this.area = this.training.areas
					this.user_group = this.training.user_groups

					let obj_img = this.training.group_training_images.find((obj) => {
						return obj.original === true
					})
					if (obj_img) this.image_url = obj_img.image

					if (this.user_group.length > 0) this.tab = 'groups'
					else this.tab = 'permissions'
				}
			},
			deep: true,
		},

		$route: function(refreshPage) {
			this.id_training = this.$route.params.id
			if (this.id_training) {
				this.fetchData()
			} else {
				this.owners.push(this.user_id)
				this.owners_list.push(`${this.user_full_name} - ${this.user_email}`)
			}

			let client = this.clients.find((obj) => {
				return obj.id === this.id_user_client_selected
			})
			this.selected_client_params = client ? client : {}
		},
	},
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>


